module.exports = __webpack_public_path__ + "img/284620916.d2cd3a71.jpg";